import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './nopage.css';
import React from 'react';
import { faCompass } from '@fortawesome/free-solid-svg-icons';

const NoPage = () => {
    return (
        <div className="no-page-wrapper">
            <h1>Oh No, you're lost!</h1>
            <div className='compass-wrapper'>
                <p><FontAwesomeIcon icon={faCompass} /></p>
            </div>
        </div>
    );
};

export default NoPage;